module.exports = __webpack_public_path__ + "img/tag.785173f7.png";